<template>
  <div class="mb-20 flex flex-col space-y-4">
    <h2 class="heading-3"><slot /></h2>
    <h3 v-if="$slots.subtitle" class="body-2"><slot name="subtitle" /></h3>
  </div>
</template>
